import { piOhDeepMerge } from "@/utils/object.helper";
/**

 */
export const getCircleData = (configData, optionData) => {
    const title = getTitle(configData, optionData);
    const series = getSeries(configData, optionData);
    const option = {
        title: title,
        visualMap: {
            show: false,
        },
        series: series,
    };
    return option;
};
/**
 * 获取标题对象, 主要是标题的位置 和 是否有副标题 ， 合并外面传进来的
 * @param configData
 * @param optionData
 * @param posData
 * @returns
 */
const getTitle = (configData, optionData) => {
    let title = {
        text: optionData.title ? optionData.title.text : "",
        top: "center",
        left: "center",
        zlevel: 0,
        textStyle: {
            color: "#10CDAC",
            fontSize: 12,
            lineHeight: 20,
        },
    };
    if (optionData.title) {
        title = piOhDeepMerge(title, optionData.title);
    }
    // 如果有副标题
    if (optionData.title && optionData.title.subtext) {
        title.text = optionData.value || "0%";
        title.textStyle.fontSize = 24;
        title.textStyle.lineHeight = 32;
        title.textStyle.fontFamily = "BebasNeue";
        title.textStyle.fontWeight = "normal";
        title.textStyle.color = optionData.color[0];
        title.itemGap = -2;
        title.top = "18%";
        title.subtext = optionData.title.subtext;
        title.textStyle.subtextStyle = {
            fontSize: "12",
            align: "center",
            color: "#646A71",
            lineHeight: 1,
        };
    }
    return title;
};
/**
 * 获取 Series 主要是 合并外面传进来的
 * @param configData
 * @param optionData
 * @param posData
 * @returns
 */
const getSeries = (configData, optionData) => {
    const value = optionData.value || "0%";
    const color = optionData.color || ["#10CDAC", "#E7FCF9"];
    const activeValue = parseFloat((parseInt(value) / 100).toFixed(2));
    const devValue = parseFloat(((100 - parseInt(value)) / 100).toFixed(2));
    let series = {
        type: "pie",
        //环形显示饼状图，实际上显示的是50-80之间的部分
        //上限不建议设置为100，echarts自带动画效果，设置为100动画效果很丑
        radius: ["85%", "100%"],
        center: ["50%", "50%"],
        data: [
            //itemSyle是单项的背景颜色设置。
            { value: activeValue, itemStyle: { color: color[0] } },
            { value: devValue, itemStyle: { color: color[1] } },
        ],
        label: {
            //将视觉引导图关闭
            show: false,
        },
        itemStyle: {
            borderRadius: 60,
        },
        // 初始化echarts的动画效果
        animationType: "scale",
        animationEasing: "elasticOut",
        animationDelay: function () {
            return Math.random() * 200;
        },
    };
    if (optionData.series && optionData.series[0]) {
        series = piOhDeepMerge(series, optionData.series[0]);
    }
    return [series];
};
